/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';
import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import { Paper, Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Divider, FormControl, FormControlLabel, Switch, FormHelperText, Typography, CircularProgress } from '@material-ui/core'

import { Autocomplete } from '@material-ui/lab'

import ConfigureWV from '../../../../CreateIC/AddDataDevice/ConfigureWV'

import Actions from '../../../../../fluid/Actions/ActionFactory'

const clone = require('rfdc')()

const blue_theme = createMuiTheme({
    palette: {
        primary: {
          main: '#2296f3',
        },
        secondary: {
            main: '#dc014e',
        }
      },
})

const styles = theme => ({

})

class RecoSourceDetail extends Component {
    state = {
        ic_name : null,
        ic_loading : false,
        ic_detail_loading : false,
        ic_detail_error : false,
        ic_list : [],
        ic_ops : [],
        wv_config : null,
        search_options : [],
        show_class : null,
        fields_in_scope : []
    }

    componentWillMount () {
        if (this.props.source !== null) {
            this.setState({
                ...this.state,
                ic_name : this.props.source.ic_name,
                show_class : this.props.source.show_class,
                search_options : this.props.source.search_options
            }, () => this.getICDetails(this.state.ic_name))
        }
    }

    updateState = (key_name, value) => {
        this.setState({...this.state, [key_name] : value})
    }

    getICs = () => {
        this.setState({...this.state, ic_loading : true}, () => {
            Actions ('http_request', {
                url : "/sainapse/information_channel",
                method : "get",
                data : {}
            }).then(res => {
                let ic_list = res.data.result.map(ic => ic.name)
                this.setState({...this.state, ic_loading : false, ic_list : ic_list})
            }).catch(err => {
                this.setState({...this.state, ic_loading : false, ic_list : []})
            })
        })
    }

    getTitle = () => {
        if (this.props.source === null) {
            return "Adding Recommendation Source to " + this.props.case_screen
        } else {
            return "Editing Recommendation Source for " + this.props.case_screen
        }  
    }

    getICDetails = (ic_name) => {
        this.setState({...this.state, ic_detail_loading : true, ic_detail_error : false}, () => {
            Actions('http_request', {
                url : "/sainapse/information_channel/" + this.state.ic_name,
                method : "get",
                data : {}
            }).then(res => {
                let ic_ops = res.data.result.operations
                let show_class
                let search_options
                let wv_config = res.data.result.world_view.configs
                if (this.props.source === null) {
                    show_class = ic_ops.includes("Classify") ? false : null
                    search_options = this.getSearchOptions(wv_config)
                }
                let fields_in_scope = []
                Actions('http_request', {
                    url : "/sainapse/information_channel/" + this.props.default_ic_name + "/information_unit/" + this.props.default_iu_name + "/field_in_scope",
                    method : "get",
                    data : {}
                }).then(res => {
                    fields_in_scope = res.data.result.map(field => field.name)
                    this.setState({
                        ...this.state, 
                        ic_ops : ic_ops, 
                        wv_config : wv_config, 
                        show_class : this.props.source === null ? show_class : this.state.show_class,
                        fields_in_scope : fields_in_scope, 
                        search_options : this.props.source === null ? search_options : this.state.search_options, 
                        ic_detail_loading : false, 
                        ic_detail_error : false
                    }, () => console.log("Source State : ", this.state))
                }).catch(err => {
                    this.setState({...this.state, ic_detail_loading : false, ic_detail_error : true})
                })
            }).catch(err => {
                this.setState({...this.state, ic_detail_loading : false, ic_detail_error : true})
            })
        })
    }

    getSearchOptions = (wv_config) => {
        let search_options = []
        let search_option = {
            operation : null,
            search_options : []
        }

        wv_config.map(config => {
            if (config.operation === "Recommend" || config.operation === "Classify") {
                let options = {...search_option}
                options.operation = config.operation
                let predictors = config.fields.filter(field => field.role === "Predictor")
                options.search_options = predictors.map(field => {
                    let option = {
                        field_name : field.name,
                        constructor : []
                    }
                    return option
                })
                search_options.push(options)
            }
        })

        return (search_options)
    }

    updateICName = (ic_name) => {
        this.setState({...this.state, ic_name : ic_name}, () => {
            this.getICDetails(ic_name)
        })
    }


    renderICSelection = () => {
        return (
            <Autocomplete
                fullWidth
                id="tags-standard"
                options={this.state.ic_list}
                value = {this.state.ic_name}
                onOpen = {() => this.getICs()}
                onChange = {(event, newValue) => this.updateICName(newValue)}
                loading = {this.state.ic_loading}
                disabled = {this.props.source !== null ? true : false}
                renderInput={(params) => (
                    <TextField
                    {...params}
                    label="Information Channel"
                    variant = 'filled'
                    size = 'small'
                    fullWidth
                    />
                )}
            />
        )
    }

    renderClassificationOperation = () => {
        return (
            <FormControl style = {{ padding : '5px'}}>
                <FormControlLabel
                    style = {{width : '100%'}}
                    control = {<Switch color = "primary" checked={this.state.show_class} onChange={(event) => this.updateState("show_class", event.target.checked)} name="show_class" />}
                    disabled = {this.state.show_class === null ? true : false}
                    label = {<Typography variant = 'body2'>Show Classification Results</Typography>}
                />
                <FormHelperText>
                    {this.state.show_class === null ? "Classification Operation is not configured for " + this.state.ic_name + "." : "Show Classification  results along with recommendations."}
                </FormHelperText>
            </FormControl>
        )
    }

    handleWVupdate = (field_map) => {
        var equal = require('deep-equal')
        console.log("Case Screen :: Deep equal Check : ", equal(field_map, this.state.search_options))
        if (!equal(field_map, this.state.search_options)) {
            this.setState({...this.state, search_options : field_map}, () => console.log("Case Screen :: Search Options : ", this.state.search_options))
        }
    }

    renderWorldViewPredictors = () => {
        let operations = this.state.ic_ops.filter(op => op === 'Recommend' || op === 'Classify')

        if (operations.length > 0) {
            return (
                // <div>
                //     <Typography style = {{display : 'block'}} variant = 'subtitle2'>{"World View Predictors for " + op}</Typography>
                //     <div style = {{width : '100%', display : 'flex', flexDirection : 'row', flexWrap : 'wrap'}}>
                //         {this.renderPredictors(op)}
                //     </div>
                // </div>
                <div>
                    <ConfigureWV
                        wv_ic_name = {this.state.ic_name}
                        ic_name = {this.props.default_ic_name} 
                        iu_name = {this.props.default_iu_name} 
                        handleNext = {(obj) => this.handleWVupdate(obj)} 
                        maxHeight = {'60vh'}
                        submit = {false}
                    />
                </div>
            )
        }
        // let predictor_configs = this.state.ic_ops.map(op => {
        //     if (op === "Recommend" || op === "Classify") {
                
        //     }
        // })

        // return predictor_configs
    }

    renderPredictors = (operation) => {
        console.log("Fields In Scope : ", this.props.fields_in_scope)
        let wv_config = this.state.wv_config.find(config => config.operation === operation)
        let predictor_fields = wv_config.fields.filter(field => field.role === "Predictor")

        let predictor_selects = predictor_fields.map(field => {
            return (
                <Autocomplete
                key = {field.name}
                multiple
                style = {{width : '100%', marginBottom : '5px'}}
                id="tags-standard"
                options={this.state.fields_in_scope}
                onChange = {(event, newValue) => this.setContructorValue(operation, field.name, newValue)}
                value = {this.getConstructorValue(operation, field.name)}
                ChipProps = {{color : 'primary', size : 'small'}}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label = {field.name}
                        variant = 'filled'
                        size = 'small'
                        helperText = {"Predictor with weight (" + field.weight + ")"} 
                    />
                )}
            />
            )
        })

        return predictor_selects
    }

    getConstructorValue = (operation, field_name) => {
        let search_option = this.state.search_options.find(option => option.operation === operation)
        let field_constructor = search_option.search_options.find(field => field.field_name === field_name).constructor
        return field_constructor
    }

    setContructorValue = (operation, field_name, value) => {
        let new_state = clone(this.state)
        let search_options = new_state.search_options
        let option = search_options.find(option => option.operation === operation)
        console.log("Option : ", option)
        let field = option.search_options.find(field => field.field_name === field_name)
        field.constructor = value

        this.setState({...new_state}, () => console.log("Source State Changed : ", this.state))
    }

    renderICDetails = () => {
        if (this.state.ic_detail_loading && !this.state.ic_detail_error) {
            return (
                <CircularProgress color = 'primary'/>
            )
        } else if (!this.state.ic_detail_loading && this.state.ic_detail_error) {
            return (
                <Typography color = 'secondary' variant = 'caption'>Error loading IC Details</Typography>
            )
        } else {
            return (
                <div style = {{width : '100%'}}>
                    {this.renderClassificationOperation()}
                    <Divider style = {{marginTop : '5px', marginBottom : '5px'}} />
                    {this.renderWorldViewPredictors()}
                </div>
            )
        }
    }

    closeDialog = () => {
        this.setState({
            ...this.state,
            ic_name : null,
            ic_loading : false,
            ic_detail_loading : false,
            ic_detail_error : false,
            ic_list : [],
            ic_ops : [],
            wv_config : null,
            search_options : [],
            show_class : null,
            reco_field_map : [],
            class_field_map : [],
            fields_in_scope : []
        }, () => this.props.onClose())
    }

    submitSource = () => {
        let source = {
            ic_name : this.state.ic_name,
            show_class : this.state.show_class,
            search_options : this.state.search_options
        }

        console.log('Submitting Source: ', source)
        this.props.update_source(source)
        this.closeDialog()
    }

    render() { 
        return (
            <ThemeProvider theme = {blue_theme}>
                <Dialog
                    fullWidth
                    open = {this.props.open}
                    onClose = {this.closeDialog}
                    maxWidth = "lg"
                >
                    <DialogTitle>{this.getTitle()}</DialogTitle>
                    <DialogContent>
                        {this.renderICSelection()}
                        <Divider style = {{marginTop : '5px', marginBottom : '5px'}}/>
                        {this.state.ic_name && this.renderICDetails()}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            color = 'primary'
                            onClick = {this.submitSource}
                        >Submit</Button>
                        <Button
                            onClick = {this.closeDialog}
                            color = 'secondary'
                        >Cancel</Button>
                    </DialogActions>
                </Dialog>
            </ThemeProvider>
        );
    }
}
 
export default withStyles(styles)(RecoSourceDetail);